export type PageMeta = {
	lang: string;
	title: string;
	description: string;
	robots: string;
	alts: { lang: string, url: string }[]
	heading: string[];
	cover: [string, string, number, number];
	
}

export function getPageMeta(pageContext: any): PageMeta {
	const data = pageContext.frontmatter || {};
	
	return {
		lang: data.lang || '',
		title: data.title || '',
		description: data.description || '',
		heading: ensureArray(data.heading || data.title || ''),
		robots: data.robots || '',
		alts: data.alts || [],
		cover: data.cover || ['lg', 'okolie/20200516_181238.jpg', 100, 60],
	}
}

function ensureArray(value: string[] | string) {
	return Array.isArray(value) ? value : [value];
}
